import { combineReducers } from "redux";
import type { ThunkDispatch } from "@reduxjs/toolkit";
import type { AnyAction } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// login
import LoginReducer from "./auth/login/reducer";

// register
import RegisterReducer from "./auth/register/reducer";

// userProfile
import ProfileReducer from "./auth/profile/reducer";

// survey
import SurveyReducer from "./survey/reducer";

// session (multi-brand active-org state — see ./session/reducer.ts)
import SessionReducer from "./session/reducer";

const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Login: LoginReducer,
    Register: RegisterReducer,
    Profile: ProfileReducer,
    Survey: SurveyReducer,
    Session: SessionReducer
});


export type RootState = ReturnType<typeof rootReducer>;

/**
 * Thunk-aware dispatch type. Added alongside the Session slice so its
 * `fetchOrganizationGrants` thunk (and any future thunks) type-check when
 * dispatched. Existing call sites that use `useDispatch<any>()` are
 * unaffected.
 */
export type AppDispatch = ThunkDispatch<RootState, unknown, AnyAction>;

export default rootReducer;